// extracted by mini-css-extract-plugin
module.exports = {"tooltipActionLink":"AccountTooltipLink__tooltipActionLink__WvR1e"};